import { createRouter, createWebHistory } from "vue-router";
import { ElMessage } from "element-plus";
import { targets } from "../security/target";
import { tienePermiso } from "../security/autorizador";

import Main from "../components/Main";
import DsHome from "../components/Home/DsHome";
import Login from "../components/Login/login";
import Solicitudes from "../components/Solicitudes";
import Remitos from "../components/Remitos";
import GestionNoticias from "../components/GestionNoticias";
import NuevaNoticia from "../components/GestionNoticias/nuevaNoticia";
import Noticia from "../components/Noticias/noticia";
import NuevaSolicitud from "../components/Solicitudes/nuevaSolicitud";
import Garantias from "../components/Garantias";
import RegistrarGarantia from "../components/Garantias/registrarGarantia";
import GarantiasExpiracion from "../components/Garantias/garantiasExpiracion";
import Pedidos from "../components/Pedidos";
import NuevoPedido from "../components/Pedidos/nuevoPedido";
import ConfirmarPedido from "../components/Pedidos/confirmarPedido";
import Info from "../components/Main/Info";
import Foro from "../components/Foro";
import NuevoPost from "../components/Foro/nuevoPost";
import Post from "../components/Foro/post";
import Perfil from "../components/Perfil";
import SolicitudPerfil from "../components/Perfil/SolicitudPerfil";
import Archivos from "../components/Archivos/";
import CargarArchivo from "../components/Archivos/cargarArchivo";
import Contacto from "../components/Contacto";
import Presupuestos from "../components/Presupuestos";
import NuevoPresupuesto from "../components/Presupuestos/nuevoPresupuesto";
import ConfirmarPresupuesto from "../components/Presupuestos/confirmarPresupuesto";
import PedidosADistribuidores from "../components/PedidosADistribuidores";
import PedidosSubAgentes from "../components/PedidosSubAgentes";
import NuevoPedidoADistribuidor from "../components/PedidosADistribuidores/nuevoPedidoADistribuidor";
import NuevoPedidoSubAgente from "../components/PedidosSubAgentes/nuevoPedidoSubAgente";
import ConfirmarPedidoADistribuidor from "../components/PedidosADistribuidores/confirmarPedidoADistribuidor";
import ConfirmarPedidoSubagente from "../components/PedidosSubAgentes/confirmarPedidoSubAgente";
import Pendientes from "../components/Pendientes";
import ResumenDeCuenta from "../components/ResumenDeCuenta";
import NewUser from "../components/Login/usuarioNuevo.vue";
import TwoFactorAuthentication from "../components/2FA"

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "Main",
      component: Main,
      children: [
        {
          path: "/",
          name: "Home",
          component: DsHome,
          //path: "/garantias",
          //name: "Home",
          //component: Garantias
        },
        {
          path: "/perfil/solicitud",
          name: "Solicitud Perfil",
          component: SolicitudPerfil,
          meta: { target: targets.Menu_Perfil },
        },
        {
          path: "/perfil",
          name: "Perfil",
          component: Perfil,
          meta: { target: targets.Menu_Perfil },
        },
        {
          path: "/2FA",
          name: "TwoFactorAuthentication",
          component: TwoFactorAuthentication,
          meta: { target: targets.Menu_2FA },
        },
        {
          path: "/archivos/edicion/:id",
          name: "Edicion Archivos",
          component: CargarArchivo,
          meta: { target: targets.Menu_Gestion_Archivo },
        },
        {
          path: "/archivos/nuevo",
          name: "Nuevo Archivo",
          component: CargarArchivo,
          meta: { target: targets.Menu_Gestion_Archivo },
        },
        {
          path: "/archivos",
          name: "Archivos",
          component: Archivos,
          meta: { target: targets.Menu_Gestion_Archivo },
        },
        {
          path: "/solicitudes",
          name: "Solicitudes",
          component: Solicitudes,
          meta: { target: targets.Menu_SolicitudServicio },
        },
        {
          path: "/solicitudes/nueva",
          name: "Nueva Solicitud",
          component: NuevaSolicitud,
          meta: { target: targets.Menu_SolicitudServicio },
        },
        {
          path: "/solicitudes/edicion/:id",
          name: "Edicion Solicitud",
          component: NuevaSolicitud,
          meta: { target: targets.Menu_SolicitudServicio },
        },
        {
          path: "/remitos",
          name: "Remitos",
          component: Remitos,
          meta: { target: targets.Menu_AsociarRemito },
        },
        {
          path: "/firmarRemitos",
          name: "Firmar Remitos",
          component: () => import("../components/FirmarRemitos"),
          meta: { target: targets.Menu_FirmarRemito },
        },
        {
          path: "/garantias",
          name: "Garantias",
          component: Garantias,
          meta: { target: targets.Menu_RegistroInstalacion },
        },
        {
          path: "/garantias/expiracion",
          name: "Garantias a vencer",
          component: GarantiasExpiracion,
          meta: { target: targets.Menu_GarantiaProximaVencer },
        },
        {
          path: "/garantias/registrar",
          name: "Registrar Garantia",
          component: RegistrarGarantia,
          meta: { target: targets.Menu_RegistroInstalacion },
        },
        //#g2
        {
          path: "/pedidos",
          name: "Pedidos",
          component: Pedidos,
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidos/alta",
          name: "Alta Pedido",
          component: NuevoPedido,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidos/detalle/:id",
          name: "Detalle Pedido",
          component: NuevoPedido,
          props: { permitirEditar: false },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidos/detalle/:id",
          name: "Edicion Pedido",
          component: NuevoPedido,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "pedidos/confirmar/:id",
          name: "ConfirmarPedido",
          component: ConfirmarPedido,
        },
        //RUTAS PARA PEDIDOS A DISTRIBUIDORES
        {
          path: "/pedidosDistribuidores",
          name: "Pedidos a Distribuidores",
          component: PedidosADistribuidores,
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidosDistribuidores/alta",
          name: "Alta Pedido a Distribuidor",
          component: NuevoPedidoADistribuidor,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidosDistribuidores/detalle/:id",
          name: "Detalle Pedido a Distribuidor",
          component: NuevoPedidoADistribuidor,
          props: { permitirEditar: false },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidosDistribuidores/detalle/:id",
          name: "Edicion Pedido a Distribuidor",
          component: NuevoPedidoADistribuidor,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "pedidosDistribuidores/confirmar/:id",
          name: "ConfirmarPedidoADistribuidor",
          component: ConfirmarPedidoADistribuidor,
        },
        //RUTAS PARA PEDIDOS SUBAGENTES
        {
          path: "/pedidosSubagentes",
          name: "Pedidos Subagentes",
          component: PedidosSubAgentes,
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidosSubagentes/alta",
          name: "Alta Pedido Subagente",
          component: NuevoPedidoSubAgente,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidosSubagentes/detalle/:id",
          name: "Detalle Pedido Subagente",
          component: NuevoPedidoSubAgente,
          props: { permitirEditar: false },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "/pedidosSubagentes/detalle/:id",
          name: "Edicion Pedido Subagente",
          component: NuevoPedidoSubAgente,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Pedido }
        },
        {
          path: "pedidosSubagentes/confirmar/:id",
          name: "ConfirmarPedidoSubagente",
          component: ConfirmarPedidoSubagente,
        },
        //RUTAS PARA PRESUPUESTOS
        {
          path: "/presupuestos",
          name: "Presupuestos",
          component: Presupuestos,
          // meta: { target: targets.Menu_Presupuesto }
        },
        {
          path: "/presupuestos/alta",
          name: "Alta Presupuesto",
          component: NuevoPresupuesto,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Presupuesto }
        },
        {
          path: "/presupuestos/detalle/:id",
          name: "Detalle Presupuesto",
          component: NuevoPresupuesto,
          props: { permitirEditar: false },
          // meta: { target: targets.Menu_Presupuesto }
        },
        {
          path: "/presupuestos/detalle/:id",
          name: "Edicion Presupuesto",
          component: NuevoPresupuesto,
          props: { permitirEditar: true },
          // meta: { target: targets.Menu_Presupuesto }
        },
        {
          path: "presupuestos/confirmar/:id",
          name: "ConfirmarPresupuesto",
          component: ConfirmarPresupuesto,
        },
        //Resumen de cuenta:
        {
          path: "/resumenDeCuenta",
          name: "Resumen de Cuenta",
          component: ResumenDeCuenta,
          //props: tienePermiso(targets.Menu_Clientes)? { buscarClientes: true } : { buscarClientes: false },
        },
        // {
        //   path: "/clientes",
        //   name: "Resumen de Cuenta Clientes",
        //   component: ResumenDeCuenta,
        //   props: { buscarClientes: true },
        // },
        {
          path: "/gestionNoticias",
          name: "Gestion Noticias",
          component: GestionNoticias,
          meta: { target: targets.Menu_Gestion_Noticia },
        },
        {
          path: "/gestionNoticias/alta",
          name: "Alta Noticia",
          component: NuevaNoticia,
          meta: { target: targets.Menu_Gestion_Noticia },
        },
        {
          path: "/gestionNoticias/edicion/:id",
          name: "Edicion Noticia",
          component: NuevaNoticia,
          meta: { target: targets.Menu_Gestion_Noticia },
        },
        {
          path: "/gestionNoticias/visualizacion/:id",
          name: "Visualizacion Noticia",
          component: Noticia,
          meta: { target: targets.Menu_Gestion_Noticia },
        },
        {
          path: "/noticia/:id",
          name: "Noticia",
          component: Noticia,
        },
        {
          path: "/foro",
          name: "Foro",
          component: Foro,
          meta: { target: targets.Menu_Foro },
        },
        {
          path: "foro/alta",
          name: "Alta Post",
          component: NuevoPost,
          meta: { target: targets.Menu_Foro },
        },
        {
          path: "/foro/:id",
          name: "Post",
          component: Post,
          meta: { target: targets.Menu_Foro },
        },
        {
          path: "/contacto",
          name: "Contacto",
          component: Contacto,
          meta: { target: targets.Menu_Contacto },
        },
        //Rutas para Pendientes
        {
          path: "/pendientes",
          name: "Pendientes",
          component: Pendientes,
          meta: { target: targets.Menu_Pendientes },
          //props: tienePermiso(targets.Menu_Clientes)? { buscarClientes: true } : { buscarClientes: false }
        },

      ],
    },
    {
      path: "/login/:user?/:code?",
      name: "Login",
      component: Login,
    },

    {
      path: "/usuarioNuevo",
      name: "NewUser",
      component: NewUser,
    },

    {
      path: "/info",
      name: "Info",
      component: Info,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // cierro todos los mensajes abiertos
  ElMessage.closeAll();

  // indica si el usuario está autorizador a navegar hacia 'to'
  let autorizado = true;

  // leo el target necesario para el destino
  let target = to.meta.target;

  //si tiene un target definido, valido si el usuario tiene permiso
  if (target) {
    autorizado = tienePermiso(target);
  }

  if (autorizado === false) {
    console.log("NAVEGACIÓN DENEGADA");
  }

  //dejo avanzar sólo si el usuario está autorizado
  next(autorizado);
});

export default router;
